import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const functions = getFunctions(app, 'europe-west1');

// Remove Firebase Functions specific code
// const API_URL = process.env.NODE_ENV === 'development'
//   ? 'http://localhost:3001' 
//   : 'https://europe-west1-craftsmanweb.cloudfunctions.net';

// Update createUser function
export const createUser = async (companyEmail, password) => {
  try {
    console.log('Creating user with:', { companyEmail, password });

    if (!companyEmail || !password) {
      console.error('Missing credentials:', { companyEmail: !!companyEmail, password: !!password });
      throw new Error('Email og password er påkrævet');
    }

    if (password.length < 6) {
      throw new Error('Password skal være mindst 6 tegn');
    }

    const userCredential = await createUserWithEmailAndPassword(auth, companyEmail, password);
    console.log('User created successfully:', userCredential.user.uid);
    return userCredential;

  } catch (error) {
    console.error('Error creating user:', error);
    if (error.code === 'auth/email-already-in-use') {
      throw new Error('Denne email er allerede registreret');
    }
    throw error;
  }
};

export default app;